import Loading from '../../utils/Loding';
import CampaignsTable from '../clinks/CampaignsTable';
import ClinkTable from './ClinkTable';
import { LookupApp } from './types';
import {
  formatNumber,
  formatCurrency,
  formatPercentage
} from './helpers';

interface LookupExpandedRowProps {
  app: LookupApp;
  onSelectTab: (app: LookupApp, tabName: string) => void;
  onCreateClink: (app: LookupApp, campaignId?: string, demandSourceId?: string) => void;
  onEditClink: (clink: any, app?: LookupApp) => void;
  onShowTrackingLinks: (clink: any, app?: LookupApp) => void;
  onShowHistory: (clink: any) => void;
  onShowStats: (app: LookupApp, clink?: any) => void;
}

const LookupExpandedRow = ({
  app,
  onSelectTab,
  onCreateClink,
  onEditClink,
  onShowTrackingLinks,
  onShowHistory,
  onShowStats
}: LookupExpandedRowProps) => {
  return (
    <tr>
      <td colSpan={8}>
        <div className="p-3 bg-light">
          {(app as any).loadingDetails ? (
            <Loading />
          ) : (
            <>
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link btn btn-link ${app.selectedTab === 'matchingCampaigns' ? 'active' : ''}`}
                    onClick={() => onSelectTab(app, 'matchingCampaigns')}
                    style={{cursor: 'pointer', border: 'none', background: 'none'}}
                    title="Shows campaigns that matched the search criteria"
                  >
                    Matching Campaigns ({app.counts?.appMatchedCampaigns || 0})
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link btn btn-link ${app.selectedTab === 'allCampaigns' ? 'active' : ''}`}
                    onClick={() => onSelectTab(app, 'allCampaigns')}
                    style={{cursor: 'pointer', border: 'none', background: 'none'}}
                    title="Shows all campaigns for this product"
                  >
                    All Campaigns ({app.counts?.appCampaigns || 0})
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link btn btn-link ${app.selectedTab === 'matchingClinks' ? 'active' : ''}`}
                    onClick={() => onSelectTab(app, 'matchingClinks')}
                    style={{cursor: 'pointer', border: 'none', background: 'none'}}
                    title="Shows cLinks that matched the search criteria"
                  >
                    Matching cLinks ({app.counts?.appMatchedClinks || 0})
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link btn btn-link ${app.selectedTab === 'allClinks' ? 'active' : ''}`}
                    onClick={() => onSelectTab(app, 'allClinks')}
                    style={{cursor: 'pointer', border: 'none', background: 'none'}}
                    title="Shows all cLinks for this product"
                  >
                    All cLinks ({app.counts?.appClinks || 0})
                  </button>
                </li>
              </ul>
              <div className="tab-content mt-3">
                {app.selectedTab === 'matchingCampaigns' && (
                  <div className="tab-pane active">
                    <CampaignsTable
                      variant="display"
                      campaigns={app.campaigns || []}
                      matchingOnly={true}
                      formatNumber={formatNumber}
                      formatPercentage={formatPercentage}
                      formatCurrency={formatCurrency}
                      onCreateClink={onCreateClink}
                      onShowStats={onShowStats}
                      app={app}
                      showCard={false}
                    />
                  </div>
                )}
                {app.selectedTab === 'allCampaigns' && (
                  <div className="tab-pane active">
                    <CampaignsTable
                      variant="display"
                      campaigns={app.campaigns || []}
                      matchingOnly={false}
                      formatNumber={formatNumber}
                      formatPercentage={formatPercentage}
                      formatCurrency={formatCurrency}
                      onCreateClink={onCreateClink}
                      onShowStats={onShowStats}
                      app={app}
                      showCard={false}
                    />
                  </div>
                )}
                {app.selectedTab === 'matchingClinks' && (
                  <div className="tab-pane active">
                    <ClinkTable
                      clinks={app.clinks || []}
                      matchingOnly={true}
                      formatNumber={formatNumber}
                      formatPercentage={formatPercentage}
                      formatCurrency={formatCurrency}
                      handleCreateClink={onCreateClink}
                      app={app}
                      onEditClink={onEditClink}
                      onShowTrackingLinks={onShowTrackingLinks}
                      onShowHistory={onShowHistory}
                      onShowStats={onShowStats}
                    />
                  </div>
                )}
                {app.selectedTab === 'allClinks' && (
                  <div className="tab-pane active">
                    <ClinkTable
                      clinks={app.clinks || []}
                      matchingOnly={false}
                      formatNumber={formatNumber}
                      formatPercentage={formatPercentage}
                      formatCurrency={formatCurrency}
                      handleCreateClink={onCreateClink}
                      app={app}
                      onEditClink={onEditClink}
                      onShowTrackingLinks={onShowTrackingLinks}
                      onShowHistory={onShowHistory}
                      onShowStats={onShowStats}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </td>
    </tr>
  );
};

export default LookupExpandedRow;